
<div class="row">
    <img [src]="imgBannerPluris" width="200">
</div>